import { useContext } from 'react';
import { LayoutContext } from '../../contexts/LayoutContext';

const SummarySection = ({ children, className = '' }) => {
  const { summaryShown } = useContext(LayoutContext);
  return summaryShown && <div className={className}>{children}</div>;
};

export default SummarySection;
